import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dms'
})
export class DmsPipe implements PipeTransform {
  transform(value: number, type: 'lat' | 'lng'): string {
    if (typeof value !== 'number' || isNaN(value)) return '';
    const abs = Math.abs(value);
    const deg = Math.floor(abs);
    const minFloat = (abs - deg) * 60;
    const min = Math.floor(minFloat);
    const sec = Math.round((minFloat - min) * 60);
    const direction = type === 'lat'
      ? value >= 0 ? 'N' : 'S'
      : value >= 0 ? 'E' : 'W';
    return `${deg}°${min}'${sec}" ${direction}`;
  }
}
